// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog__header{background:#1a243e;display:flex}.nopadding .el-dialog__body{padding:0}.el-table:before{z-index:inherit}.el-table .notice-row{background:#ff5151}.el-table .light-row{background:#f0f9eb}.dialogFullSc .el-dialog__body{height:calc(100% - 60px);width:100%}.dialogLessSc .el-dialog__body{height:500px;width:100%}.cursor{cursor:pointer}", ""]);
// Exports
module.exports = exports;
